import { render, staticRenderFns } from "./productitems.vue?vue&type=template&id=4f411e70&"
import script from "./productitems.vue?vue&type=script&lang=js&"
export * from "./productitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports